module.exports = __webpack_public_path__ + "img/worth_1.288eb8c4.png";